import React from 'react';
import ObjectMenu from '../toolbars/ObjectMenu/ObjectMenu';
import Stylus from './Stylus';
import type WhiteboardController from '../controllers/WhiteboardController';

class StylusCurrentShape extends Stylus {
  private currentStylus: Stylus;

  constructor({
    controller,
    currentStylus,
  }: {
    controller: WhiteboardController;
    currentStylus: Stylus;
  }) {
    super({ controller });
    this.currentStylus = currentStylus;
  }

  activate(): void {
    this.currentStylus.activate();
  }

  subMenu() {
    return ObjectMenu;
  }

  subMenuName() {
    return 'shapes';
  }

  iconClass() {
    return 'fa-regular fa-shapes';
  }

  renderIcon() {
    return <aha-icon icon={this.iconClass()} />;
  }

  description(): string {
    return 'shape';
  }

  setCurrentStylus(stylus: Stylus): void {
    this.currentStylus = stylus;
  }

  cursor() {
    return this.currentStylus.cursor();
  }
}

export default StylusCurrentShape;
